module.exports = __webpack_public_path__ + "img/structured-resumes.40c72768.svg";